// extracted by mini-css-extract-plugin
export default {"form":"editOfferForm_form__Mulct","label":"editOfferForm_label__bYShT"};